import { useTranslation } from 'react-i18next';

interface TeacherFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  classFilter: string;
  onClassFilterChange: (cls: string) => void;
  roleFilter: string;
  onRoleFilterChange: (role: string) => void;
  showInactive: boolean;
  onToggleInactive: (value: boolean) => void;
  classOptions: string[];
  roleOptions: string[];
}

export default function TeacherFilters({
  searchQuery,
  onSearchChange,
  classFilter,
  onClassFilterChange,
  roleFilter,
  onRoleFilterChange,
  showInactive,
  onToggleInactive,
  classOptions,
  roleOptions,
}: TeacherFiltersProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
      <div className="relative w-full sm:w-72">
        <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t('teachers.searchTeachers')}
          className="xl-input pl-9 text-sm"
        />
      </div>

      <select value={classFilter} onChange={(e) => onClassFilterChange(e.target.value)} className="xl-input text-sm cursor-pointer w-full sm:w-44">
        <option value="">{t('teachers.allClasses')}</option>
        {classOptions.map((c) => (
          <option key={c} value={c}>{c}</option>
        ))}
      </select>

      <select value={roleFilter} onChange={(e) => onRoleFilterChange(e.target.value)} className="xl-input text-sm cursor-pointer w-full sm:w-48">
        <option value="">{t('teachers.allRoles')}</option>
        {roleOptions.map((r) => (
          <option key={r} value={r}>{r}</option>
        ))}
      </select>

      <button
        type="button"
        onClick={() => onToggleInactive(!showInactive)}
        className={`inline-flex items-center gap-2 h-9 px-3 rounded-full text-xs font-label font-medium transition-colors cursor-pointer whitespace-nowrap border ${
          showInactive ? 'bg-semantic-warning-bg border-semantic-warning/30 text-semantic-warning' : 'bg-background-100 border-background-200 text-foreground-500 hover:bg-background-200'
        }`}
      >
        <i className={`text-sm ${showInactive ? 'ri-eye-line' : 'ri-eye-off-line'}`} />
        {showInactive ? t('students.showingInactive') : t('students.hideInactive')}
      </button>

      {(classFilter || roleFilter || searchQuery) && (
        <span className="text-xs font-label font-medium text-foreground-500 bg-background-100 px-2.5 py-1 rounded-full whitespace-nowrap">
          {t('teachers.filtered')}
        </span>
      )}
    </div>
  );
}